import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/insure/',
    component:layout,
    children:[
        {name: '保险产品', path: 'index', component: ()=>_import('index')},
		{name: '产品详情', path: 'detail', component: ()=>_import('detail')},
		{name: '填写保单', path: 'createOrder', component: ()=>_import('createOrder')},
		{name: '投保指南', path: 'insureGuide', component: ()=>_import('insureGuide')},
		{name: '理赔指南', path: 'claimsGuide', component: ()=>_import('claimsGuide')},
        // add route here
    ]
}